import React, { useEffect } from "react";
import { createContext, useState } from "react";
import { SecurityQuestion } from "../Models/SecurityQuestion";
import { UsernameValidation } from "../Models/PolicyInfo";

const DataContext = createContext({});

interface Props {
  children: JSX.Element;
}

export const DataProvider = ({ children }: Props) => {
  const [appHasState, setAppHasState] = useState(true);
  const [jwtToken, setJwtToken] = useState("");
  const [certified, setCertified] = useState(false);
  const [haveClaim, setHaveClaim] = useState(false);
  const [guid, setGuid] = useState<string | null>(null);
  const [checkingData, setCheckingData] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [validKey, setValidKey] = useState(false);

  const [usernameValid, setUsernameValid] = useState<UsernameValidation>({
    empty: true,
    invalid: false,
    isShort: true,
    touched: false,
    nonLegitChars: true,
  });

  const [policy, setPolicy] = useState("");
  const [fein, setFein] = useState("");
  const [guidError, setGuidError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [permPolicyClaim, setPermPolicyClaim] = useState(false);
  const [permReportPay, setPermReportPay] = useState(false);
  const [permCertificates, setPermCertificates] = useState(false);
  const [permUMView, setPermUMView] = useState(false);
  const [permUMFullAccess, setPermUMFullAccess] = useState(false);
  const [permPolicyAdmin, setPermPolicyAdmin] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [yourTitle, setYourTitle] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [yourExtension, setYourExtension] = useState("");
  const [progressState, setProgressState] = useState(3);

  const [securityQuestions, setSecurityQuestions] = useState<
    SecurityQuestion[] | null
  >(null);
  const [question1, setQuestion1] = useState<SecurityQuestion>({
    id: "",
    questionText: "",
  });
  const [question2, setQuestion2] = useState<SecurityQuestion>({
    id: "",
    questionText: "",
  });
  const [question3, setQuestion3] = useState<SecurityQuestion>({
    id: "",
    questionText: "",
  });
  const [question1Answer, setQuestion1Answer] = useState("");
  const [question2Answer, setQuestion2Answer] = useState("");
  const [question3Answer, setQuestion3Answer] = useState("");
  const [confViewed, setConfViewed] = useState<boolean>(false);

  const [errorPageMsg, setErrorPageMsg] = useState("");

  const clearState = () => {
    setGuid("");
    setFirstName("");
    setLastName("");
    setPolicy("");
    setFein("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setUsername("");
    setCompanyName("");
    setPhoneNumber("");
    setQuestion1Answer("");
    setQuestion2Answer("");
    setQuestion3Answer("");
    setJwtToken("");
    sessionStorage.clear();
  };

  useEffect(() => {
    clearState();
  }, [appHasState]);

  const isSanitized = (testval: string): boolean => {
    let BadWords: string[] = [
      "{",
      "}",
      "<",
      ">",
      "[",
      "]",
      "https://",
      "http://",
      "www.",
    ];
    if (
      BadWords.some((str: string) => testval.toLowerCase().includes(str.toLowerCase())
      )
    ) {
      return false;
    }
    return true;
  };

  return (
    <DataContext.Provider
      value={{
        guid,
        email,
        setEmail,
        username,
        setUsername,
        usernameValid,
        setUsernameValid,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        setGuid,
        checkingData,
        setCheckingData,
        guidError,
        setGuidError,
        policy,
        setPolicy,
        permPolicyClaim,
        setPermPolicyClaim,
        permReportPay,
        setPermReportPay,
        permCertificates,
        setPermCertificates,
        permUMView,
        setPermUMView,
        permUMFullAccess,
        setPermUMFullAccess,
        permPolicyAdmin,
        setPermPolicyAdmin,
        fein,
        setFein,
        isModalOpen,
        setIsModalOpen,
        certified,
        setCertified,
        haveClaim,
        setHaveClaim,
        companyName,
        setCompanyName,
        yourTitle,
        setYourTitle,
        phoneNumber,
        setPhoneNumber,
        yourExtension,
        setYourExtension,
        password,
        setPassword,
        confirmPassword,
        setConfirmPassword,
        progressState,
        setProgressState,
        securityQuestions,
        setSecurityQuestions,
        question1,
        setQuestion1,
        question2,
        setQuestion2,
        question3,
        setQuestion3,
        question1Answer,
        setQuestion1Answer,
        question2Answer,
        setQuestion2Answer,
        question3Answer,
        setQuestion3Answer,
        confViewed,
        setConfViewed,
        errorPageMsg,
        setErrorPageMsg,
        validKey,
        setValidKey,
        setAppHasState,
        jwtToken, 
        setJwtToken,
        isSanitized
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
export default DataContext;
